import React from 'react';
import './FeaturedProjects.css';

const FeaturedProjects = () => {
  const projects = [
    {
  id: -9,
  title: "JECRC Welcomes Vikrant Massey",
  image: "https://img.youtube.com/vi/5JrMq6z2tNg/hqdefault.jpg",
  description:
    "An actor known for his versatility, authenticity, and powerful storytelling, Vikrant represents the spirit of dreaming big and staying grounded values that define every JECRCian.",
  link: "https://youtu.be/5JrMq6z2tNg?si=fccH0IV0jZwjG5lk",
},
    {
  id: -8,
  title: 'Taarak Mehta Ka Ooltah Chashmah | Special Clip',
  image: 'https://img.youtube.com/vi/Luj6VP81SNo/hqdefault.jpg',
  description:
    'Another fun moment from the iconic sitcom Taarak Mehta Ka Ooltah Chashmah packed with humor and entertainment.',
  link: 'https://youtu.be/Luj6VP81SNo?si=Yg_qr9iwX2xrSYGD',
},
    {
      id: -7,
      title: 'Taarak Mehta Ka Ooltah Chashmah | Teaser',
      image: 'https://img.youtube.com/vi/CQh1szl8Bv4/hqdefault.jpg',
      description:
        'A special teaser from the iconic show Taarak Mehta Ka Ooltah Chashmah bringing humor, drama and excitement together.',
      link: 'https://youtu.be/CQh1szl8Bv4?si=gAB2VG_E05Q8sa3m',
    },
    {
      id: -6,
      title:
        'Jaipur me Shuru Hui बबली के पतंग काटने की तैयारी! | Taarak Mehta ka Ooltah Chashmah',
      image: 'https://img.youtube.com/vi/TmuuDq0jvl0/hqdefault.jpg',
      description:
        'The fun begins in Jaipur as Babli prepares for the ultimate kite-cutting challenge in this entertaining moment from TMKOC.',
      link: 'https://youtu.be/TmuuDq0jvl0?si=M3rBuOttUH5JvRrI',
    },
    {
      id: -5,
      title: 'Babli Vs Popatlal | Taarak Mehta Ka Ooltah Chashmah',
      image: 'https://img.youtube.com/vi/6KYO4o0BSh8/hqdefault.jpg',
      description:
        'A hilarious clash between Babli and Popatlal from the beloved sitcom Taarak Mehta Ka Ooltah Chashmah.',
      link: 'https://youtu.be/6KYO4o0BSh8?si=RH5QOPbhapVWg0lN',
    },
    {
      id: -4,
      title:
        'EXCLUSIVE!! A never before seen unreleased collaboration with Cricket Bazaar & @dotmedia',
      image: 'https://img.youtube.com/vi/EQkHBOI0gFM/hqdefault.jpg',
      description:
        'An exclusive, never-before-seen collaboration between Cricket Bazaar and @dotmedia. A unique blend of cricketing passion and creative storytelling.',
      link: 'https://drive.google.com/file/d/1GGnC1i6PS4nVW46OUzrEXGqHlSId1jTj/preview',
    },
    {
      id: -3,
      title:
        'Ab Milega Non-Stop Cricket Ka Tandoori Tadka – Cricket Bazaar Chalu Che!',
      image: 'https://img.youtube.com/vi/EQkHBOI0gFM/hqdefault.jpg',
      description:
        'Cricket Bazaar is your one-stop destination for everything about cricket – live scores, news, schedules and nonstop cricketing chaos!',
      link: 'https://www.youtube.com/watch?v=EQkHBOI0gFM',
    },
    {
      id: -2,
      title: 'Luminous | Need End-to-End Solar Solutions?',
      image: 'https://img.youtube.com/vi/GtvnY0rlWH4/hqdefault.jpg',
      description:
        "Luminous Solar - India's only true end-to-end solar expert bringing powerful solar solutions across the nation.",
      link: 'https://www.youtube.com/watch?v=GtvnY0rlWH4&ab_channel=LuminousIndia',
    },
    {
      id: -1,
      title: 'Luminous - Solar Experts',
      image: 'https://img.youtube.com/vi/8IkoDrYnPn8/hqdefault.jpg',
      description: 'Luminous solar experts delivering reliable solar innovation.',
      link: 'https://youtu.be/8IkoDrYnPn8?si=igqYBMiScqxDiUZL',
    },
    {
      id: 0,
      title: 'Dekha Ji Dekha Maine - New Release',
      image: 'https://img.youtube.com/vi/TJ2Um2gQ4E0/hqdefault.jpg',
      description: 'Latest T-Series music release.',
      link: 'https://youtu.be/TJ2Um2gQ4E0?si=YAp2AJ94pFBKxsh5',
    },
    {
      id: 1,
      title: 'Twamev',
      description: 'Truly You.',
      image: 'https://img.youtube.com/vi/OFiHoLAAyPw/hqdefault.jpg',
      link: 'https://youtu.be/OFiHoLAAyPw?si=uvvcjrzS5C4dfJUd',
    },
    {
      id: 2,
      title: 'Twamev',
      description: 'A mix of past.',
      image: 'https://img.youtube.com/vi/5TpJN-lGyPU/hqdefault.jpg',
      link: 'https://youtu.be/5TpJN-lGyPU?si=VAJ8N2SC9rSmQiNn',
    },
    {
      id: 3,
      title: 'Twamev',
      description: 'I am grace.',
      image: 'https://img.youtube.com/vi/KjGsKOiznPM/hqdefault.jpg',
      link: 'https://youtu.be/KjGsKOiznPM?si=5czVp0E4fNP73H5y',
    },
    {
      id: 4,
      title: 'Mismatched S3 | Netflix India',
      description:
        'Dimple and Rishi return with more love and chaos in the new season of Mismatched.',
      image: 'https://img.youtube.com/vi/b87uNYutCLs/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=b87uNYutCLs&ab_channel=NetflixIndia',
    },
    {
      id: 5,
      title: 'Mr. & Mrs. Mahi | Netflix India',
      description:
        'Watch Mr. & Mrs. Mahi chase their dreams in this heartfelt sports drama.',
      image: 'https://img.youtube.com/vi/vB7OiVfmEDM/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=vB7OiVfmEDM&ab_channel=NetflixIndia',
    },
    {
      id: 6,
      title: 'Air India New Identity',
      description:
        'Reimagining the legacy of Air India with a bold and modern new brand identity.',
      image: 'https://img.youtube.com/vi/al51WZcN2_U/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=al51WZcN2_U&ab_channel=AirIndiaOfficial',
    },
    {
      id: 7,
      title: 'Tata Motors Cars | Built for the Bold',
      description:
        'Explore bold design and engineering from Tata Motors Cars.',
      image: 'https://img.youtube.com/vi/9QFe0eELKws/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=9QFe0eELKws&ab_channel=TataMotorsCars',
    },
    {
      id: 8,
      title: 'Parachute Advansed | Coconut Hair Oil',
      description:
        'Rediscover the timeless beauty of coconut hair oil with Parachute Advansed.',
      image: 'https://img.youtube.com/vi/rJj-HQ3mJvE/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=rJj-HQ3mJvE&ab_channel=ParachuteAdvansed',
    },
    {
      id: 9,
      title: '7 Wonders Music | Calm Symphony',
      description: 'Experience the calm symphonies from 7 Wonders Music.',
      image: 'https://img.youtube.com/vi/yADhUV2GR-0/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=yADhUV2GR-0&ab_channel=7WondersMusic',
    },
    {
      id: 10,
      title: 'Game Theory | Strategic Thinking',
      description: 'Unlock strategic thinking concepts with Game Theory.',
      image: 'https://img.youtube.com/vi/xcj_8Y4Uh1k/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=xcj_8Y4Uh1k&ab_channel=GameTheory',
    },
    {
      id: 11,
      title: 'Neelkanth IVF | Parenthood Journey',
      description: 'Join the journey of parenthood with Neelkanth IVF.',
      image: 'https://img.youtube.com/vi/tZJTlEJXlYo/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=tZJTlEJXlYo&ab_channel=NeelkanthIVF',
    },
    {
      id: 12,
      title: 'Candi L | Sweet Moments',
      description: 'Cherish life’s sweetest moments with Candi L.',
      image: 'https://img.youtube.com/vi/pUjPP6tdYc0/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=pUjPP6tdYc0&ab_channel=CandiL.',
    },
    {
      id: 13,
      title: 'Rajasthan Tourism | Discover Rajasthan',
      description: 'Explore the vibrant culture and heritage of Rajasthan.',
      image: 'https://img.youtube.com/vi/nZP9OL698as/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=nZP9OL698as&ab_channel=RajasthanTourism',
    },
    {
      id: 14,
      title: 'Desi Dutch Originals | Fusion Beats',
      description: 'A musical fusion of cultures from Desi Dutch Originals.',
      image: 'https://img.youtube.com/vi/qbHW5huTBPE/hqdefault.jpg',
      link: 'https://www.youtube.com/watch?v=qbHW5huTBPE&ab_channel=DesiDutchOriginals',
    },
  ];

  return (
    <section className="featured-projects">
      <div className="container">
        <h2 className="featured-projects-title">Featured Projects</h2>

        <div className="projects-grid">
          {projects.map((project) => (
            <div className="project-card" key={project.id}>
              <img
                src={project.image}
                alt={project.title}
                className="project-image"
              />

              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>

                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="view-project-button"
                >
                  Watch
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;